<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
import { useAnalysisStore } from '@/store/modules/analysis';
import {
  removeAsterisk,
  splitKeywordParts,
  splitBySentence,
  splitSentencesByDivider,
  splitCommaSeparatedWords,
} from '@/composables/splitSentence';

const props = defineProps({
  pData: Object,
  userName: String,
  isMobile: Boolean,
});
const store = useAnalysisStore();
// const userName = computed(() => store.userName)
onMounted(() => {
  // pData.value = store.analysisResult;
});

const priorityCareerReco = computed(() => splitBySentence(props.pData.진로추천.우선추천));
const priorityCRItems = computed(() => props.pData.진로추천.추천분야.우선추천분야);

const majorRecoList = computed(() => {
  const raw = props.pData?.진로학과?.우선추천분야 || {};
  return Object.entries(raw).map(([key, value]) => ({
    key,
    descriptionSentences: splitBySentence(value.설명),
    majors: value.학과,
  }));
});
</script>

<template>
  <VRow class="full-height">
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
      <VCard class="personality-card full-height right">
        <div class="detail-card__top-title personality">
          <span class="detail-tit__num personality">11</span>
          <span class="detail-tit__txt personality">
            <span>성향과 조화로운 우선 추천 진로,&nbsp;</span>
            <span>어떤 진로가 잘 맞을까요?</span>
          </span>
        </div>
        <div class="personality-wrapper">
          <div class="personal-career-notice">
            <div class="nangman-magnifire-img"></div>
            <div class="personal-career-container">
              <div class="personal-career-triangle" :class="{ mobile: isMobile }"></div>
              <div class="personal-career-txt">
                이 추천은 사주분석의 성향분석을 기반으로 한 경향성 안내입니다.<br />
                나에게 잘 맞는 길을 찾는 여정에 작은 참고가 되었으면 합니다.
              </div>
            </div>
          </div>
          <div class="person-desc-box">
            <div class="desc__title">👍 당신의 성향과 부드럽게 조화를 이루는 직업들이예요.</div>
            <div class="desc__body job">
              <div class="career__circle-box">
                <div
                  v-for="(item, idx) in priorityCRItems"
                  :key="idx"
                  class="career-circle primary"
                >
                  <span class="circle__main-txt">
                    {{ item }}
                  </span>
                </div>
              </div>
              <div v-for="(sentence, idx) in priorityCareerReco" :key="idx">
                <span class="content__body-txt">
                  <template v-for="(part, pIdx) in splitKeywordParts(sentence)" :key="pIdx">
                    <span v-if="part.isKeyword" class="p-keyword">{{ part.text }}</span>
                    <template v-else>{{ part.text }}</template>
                  </template>
                </span>
              </div>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <VCard class="personality-card full-height">
        <div class="personality-wrapper">
          <span class="career-title">🔗 진로학과 연결</span>
          <section
            v-for="(reco, recoIdx) in majorRecoList"
            :key="recoIdx"
            class="career__major-reco"
          >
            <div class="major__top">
              <span class="major__top-title">{{ reco.key }}</span>
              <!-- TODO: 아이콘 - 백엔드에 반환 요청 혹은 기획 요청 -->
              <div class="major__top-keyword">
                <span v-for="(major, mIdx) in reco.majors" :key="mIdx" class="major-keyword">
                  {{ major }}
                </span>
              </div>
            </div>
            <div class="major__bottom">
              <div v-for="(sentence, idx) in reco.descriptionSentences" :key="idx">
                <span class="content__body-txt">
                  <template v-for="(part, pIdx) in splitKeywordParts(sentence)" :key="pIdx">
                    <span v-if="part.isKeyword" class="p-keyword">{{ part.text }}</span>
                    <template v-else>{{ part.text }}</template>
                  </template>
                </span>
              </div>
            </div>
          </section>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>
<style scoped>
.nangman-magnifire-img {
  background: url('@manseImages/personality/personality-career-nangman.png') center center no-repeat;
  background-size: contain;
  width: 140px;
  aspect-ratio: 1/1;
}
.career-title {
  color: var(--Gray-800, #333);
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
</style>
